export { Page as default } from '@ui/views/Stake';
export { getStaticProps } from '@ui/views/Stake/getStatic';
